export class HelmSetValue {
    Key!: string;
    Value!: string;
    constructor(key: string, value: string) {
        this.Key = key;
        this.Value = value;
    }
    public asString(newLine: string): string {
        return `--set ${this.Key.trim()}="${this.Value.trim()}" ${newLine}`;
    }
}
export class HelmUpgradeCommandBuilder {
    private readonly newLine: string;
    private readonly commandHeadTokens: string[];
    private readonly commandTailTokens: string[];
    private readonly releaseSpecificSetValues: HelmSetValue[] = [];
    constructor(version: string, namespace: string, releaseName: string, registryUrl: string, lineBreakCharacter: string) {
        this.newLine = `${lineBreakCharacter}\n`;
        this.commandHeadTokens = ["helm upgrade --atomic ", this.newLine, `--namespace ${namespace} `, this.newLine, `--reset-then-reuse-values `, this.newLine, `--version "${version}" `, this.newLine];
        this.commandTailTokens = [releaseName, " ", this.newLine, registryUrl];
    }
    public withValues(setValues: HelmSetValue[]) {
        setValues
            .filter((kvp) => kvp.Key.trim() !== "" && kvp.Value.trim() !== "")
            .forEach((v) => {
            this.releaseSpecificSetValues.push(v);
        });
        return this;
    }
    public toCommandString(): string {
        const allTokens = this.commandHeadTokens.concat(this.releaseSpecificSetValues.map((kv) => kv.asString(this.newLine))).concat(this.commandTailTokens);
        return allTokens.join("").trim();
    }
}
